@file:OptIn(InternalResourceApi::class)

package mobile_wallet.feature.history.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/mobile_wallet.feature.history.generated.resources/"

internal val Res.string.feature_history_account_balance: StringResource by lazy {
      StringResource("string:feature_history_account_balance", "feature_history_account_balance", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 63),
      ))
    }

internal val Res.string.feature_history_account_number: StringResource by lazy {
      StringResource("string:feature_history_account_number", "feature_history_account_number", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 74, 54),
      ))
    }

internal val Res.string.feature_history_all: StringResource by lazy {
      StringResource("string:feature_history_all", "feature_history_all", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 129, 31),
      ))
    }

internal val Res.string.feature_history_credits: StringResource by lazy {
      StringResource("string:feature_history_credits", "feature_history_credits", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 161, 43),
      ))
    }

internal val Res.string.feature_history_debited_from: StringResource by lazy {
      StringResource("string:feature_history_debited_from", "feature_history_debited_from", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 205, 52),
      ))
    }

internal val Res.string.feature_history_debits: StringResource by lazy {
      StringResource("string:feature_history_debits", "feature_history_debits", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 258, 38),
      ))
    }

internal val Res.string.feature_history_description: StringResource by lazy {
      StringResource("string:feature_history_description", "feature_history_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 297, 67),
      ))
    }

internal val Res.string.feature_history_empty: StringResource by lazy {
      StringResource("string:feature_history_empty", "feature_history_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 474, 73),
      ))
    }

internal val Res.string.feature_history_empty_filter: StringResource by lazy {
      StringResource("string:feature_history_empty_filter", "feature_history_empty_filter", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 365, 108),
      ))
    }

internal val Res.string.feature_history_error: StringResource by lazy {
      StringResource("string:feature_history_error", "feature_history_error", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 638, 93),
      ))
    }

internal val Res.string.feature_history_error_fallback: StringResource by lazy {
      StringResource("string:feature_history_error_fallback", "feature_history_error_fallback", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 548, 46),
      ))
    }

internal val Res.string.feature_history_error_oops: StringResource by lazy {
      StringResource("string:feature_history_error_oops", "feature_history_error_oops", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 595, 42),
      ))
    }

internal val Res.string.feature_history_filter_apply: StringResource by lazy {
      StringResource("string:feature_history_filter_apply", "feature_history_filter_apply", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 732, 56),
      ))
    }

internal val Res.string.feature_history_filter_by_account: StringResource by lazy {
      StringResource("string:feature_history_filter_by_account", "feature_history_filter_by_account", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 789, 69),
      ))
    }

internal val Res.string.feature_history_filter_clear_all: StringResource by lazy {
      StringResource("string:feature_history_filter_clear_all", "feature_history_filter_clear_all", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 859, 52),
      ))
    }

internal val Res.string.feature_history_filter_content_desc: StringResource by lazy {
      StringResource("string:feature_history_filter_content_desc", "feature_history_filter_content_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 912, 51),
      ))
    }

internal val Res.string.feature_history_filter_title: StringResource by lazy {
      StringResource("string:feature_history_filter_title", "feature_history_filter_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 964, 64),
      ))
    }

internal val Res.string.feature_history_filter_transaction_type: StringResource by lazy {
      StringResource("string:feature_history_filter_transaction_type", "feature_history_filter_transaction_type", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1029, 71),
      ))
    }

internal val Res.string.feature_history_header_account: StringResource by lazy {
      StringResource("string:feature_history_header_account", "feature_history_header_account", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1101, 58),
      ))
    }

internal val Res.string.feature_history_header_all: StringResource by lazy {
      StringResource("string:feature_history_header_all", "feature_history_header_all", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1160, 58),
      ))
    }

internal val Res.string.feature_history_header_credit: StringResource by lazy {
      StringResource("string:feature_history_header_credit", "feature_history_header_credit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1219, 65),
      ))
    }

internal val Res.string.feature_history_header_debit: StringResource by lazy {
      StringResource("string:feature_history_header_debit", "feature_history_header_debit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1285, 60),
      ))
    }

internal val Res.string.feature_history_loading: StringResource by lazy {
      StringResource("string:feature_history_loading", "feature_history_loading", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1346, 43),
      ))
    }

internal val Res.string.feature_history_no_transactions_found: StringResource by lazy {
      StringResource("string:feature_history_no_transactions_found", "feature_history_no_transactions_found", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1390, 73),
      ))
    }

internal val Res.string.feature_history_other: StringResource by lazy {
      StringResource("string:feature_history_other", "feature_history_other", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1464, 37),
      ))
    }

internal val Res.string.feature_history_paid_to: StringResource by lazy {
      StringResource("string:feature_history_paid_to", "feature_history_paid_to", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1502, 43),
      ))
    }

internal val Res.string.feature_history_pan_id: StringResource by lazy {
      StringResource("string:feature_history_pan_id", "feature_history_pan_id", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1546, 38),
      ))
    }

internal val Res.string.feature_history_select_account: StringResource by lazy {
      StringResource("string:feature_history_select_account", "feature_history_select_account", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1585, 58),
      ))
    }

internal val Res.string.feature_history_share: StringResource by lazy {
      StringResource("string:feature_history_share", "feature_history_share", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1644, 37),
      ))
    }

internal val Res.string.feature_history_specific_transactions_history: StringResource by lazy {
      StringResource("string:feature_history_specific_transactions_history", "feature_history_specific_transactions_history", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1682, 93),
      ))
    }

internal val Res.string.feature_history_title: StringResource by lazy {
      StringResource("string:feature_history_title", "feature_history_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1776, 41),
      ))
    }

internal val Res.string.feature_history_transaction_date: StringResource by lazy {
      StringResource("string:feature_history_transaction_date", "feature_history_transaction_date", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1818, 68),
      ))
    }

internal val Res.string.feature_history_transaction_details: StringResource by lazy {
      StringResource("string:feature_history_transaction_details", "feature_history_transaction_details", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1887, 71),
      ))
    }

internal val Res.string.feature_history_transaction_id: StringResource by lazy {
      StringResource("string:feature_history_transaction_id", "feature_history_transaction_id", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1959, 62),
      ))
    }

internal val Res.string.feature_history_view_Receipt: StringResource by lazy {
      StringResource("string:feature_history_view_Receipt", "feature_history_view_Receipt", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2022, 52),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("feature_history_account_balance", Res.string.feature_history_account_balance)
  map.put("feature_history_account_number", Res.string.feature_history_account_number)
  map.put("feature_history_all", Res.string.feature_history_all)
  map.put("feature_history_credits", Res.string.feature_history_credits)
  map.put("feature_history_debited_from", Res.string.feature_history_debited_from)
  map.put("feature_history_debits", Res.string.feature_history_debits)
  map.put("feature_history_description", Res.string.feature_history_description)
  map.put("feature_history_empty", Res.string.feature_history_empty)
  map.put("feature_history_empty_filter", Res.string.feature_history_empty_filter)
  map.put("feature_history_error", Res.string.feature_history_error)
  map.put("feature_history_error_fallback", Res.string.feature_history_error_fallback)
  map.put("feature_history_error_oops", Res.string.feature_history_error_oops)
  map.put("feature_history_filter_apply", Res.string.feature_history_filter_apply)
  map.put("feature_history_filter_by_account", Res.string.feature_history_filter_by_account)
  map.put("feature_history_filter_clear_all", Res.string.feature_history_filter_clear_all)
  map.put("feature_history_filter_content_desc", Res.string.feature_history_filter_content_desc)
  map.put("feature_history_filter_title", Res.string.feature_history_filter_title)
  map.put("feature_history_filter_transaction_type", Res.string.feature_history_filter_transaction_type)
  map.put("feature_history_header_account", Res.string.feature_history_header_account)
  map.put("feature_history_header_all", Res.string.feature_history_header_all)
  map.put("feature_history_header_credit", Res.string.feature_history_header_credit)
  map.put("feature_history_header_debit", Res.string.feature_history_header_debit)
  map.put("feature_history_loading", Res.string.feature_history_loading)
  map.put("feature_history_no_transactions_found", Res.string.feature_history_no_transactions_found)
  map.put("feature_history_other", Res.string.feature_history_other)
  map.put("feature_history_paid_to", Res.string.feature_history_paid_to)
  map.put("feature_history_pan_id", Res.string.feature_history_pan_id)
  map.put("feature_history_select_account", Res.string.feature_history_select_account)
  map.put("feature_history_share", Res.string.feature_history_share)
  map.put("feature_history_specific_transactions_history", Res.string.feature_history_specific_transactions_history)
  map.put("feature_history_title", Res.string.feature_history_title)
  map.put("feature_history_transaction_date", Res.string.feature_history_transaction_date)
  map.put("feature_history_transaction_details", Res.string.feature_history_transaction_details)
  map.put("feature_history_transaction_id", Res.string.feature_history_transaction_id)
  map.put("feature_history_view_Receipt", Res.string.feature_history_view_Receipt)
}
